import { ApiDataAdapter } from '@internal-libraries/kheops-ui-lib'
import PermissionsDto from './PermissionsDto'

export class PermissionsApiAdapter implements ApiDataAdapter<PermissionsDto> {
    public createClass(apiData: PermissionsDto): PermissionsDto {
        return apiData
    }
}
